import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";
import { subDays } from "date-fns";

const initialState = {
     currentPage: 1,
     scrollPage: 1,
     currentFilter: null,
     currentPageSize: 10,
     start: subDays(new Date(), 30),
      end: new Date(),
     clearSelection: false,
     queryData: {},
     queryStatus: "idle",
     sortBy: "",
     sortOrder: "desc",
     search: "",
     showCreateModal: false,
     selectedId: "",
     selectedItemsDetails: "",
     is_edit: false,
     userEditStatus:'idle',
     isEditLoading: false
 
}

export const updateUser = createAsyncThunk(
     `/admin/users/update`,
     async ({data}, { rejectWithValue }) => {
          const api = await getAxiosInstance();
          try {
               const response = await api.post("/admin/users/update", data);
               return response.data;
          } catch (error) {
               return rejectWithValue(error.response.data);
          }
     }
)

export const getUserEditData = createAsyncThunk(
     'admin/users/view',
     async (data, { rejectWithValue }) => {  
          const api = await getAxiosInstance();
          try {
               const response = await api.get(`/admin/users/view?user_id=${data}`);
               return response.data;
          } catch (error) {
               return rejectWithValue(error.response.data)
          }
     }
)


const userSlice = createSlice({
     name: 'user',
     initialState,
     reducers: {
          updateConfig: (state, action) => {
               action.payload(state);
          }
     },
     extraReducers: (builder) => {
          builder
          .addCase(getUserEditData.pending, (state, action) => {
               state.isEditLoading = true;
               state.error = null;
             })
            .addCase(getUserEditData.fulfilled, (state, action) => {
              state.selectedItemsDetails = action.payload.data;
              state.error = null;
              localStorage.setItem(
               "userDetails",
               JSON.stringify(action.payload.data)
             );
            })
            .addCase(getUserEditData.rejected, (state, action) => {
              state.selectedItemsDetails = null;
              state.error = action.payload;
            });
        },
})



export const { updateConfig } = userSlice.actions;
export default userSlice.reducer;